import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import { createLookupApi } from "../../api/lookupApi";
import { listClassConfigurations } from "../../api/classConfigurationApi";
import { getStudentDailySection } from "../../api/attendanceReportApi";
import "./Attendance.css";

const periodApi = createLookupApi("periods");
const today = () => new Date().toISOString().slice(0, 10);

/**
 * Direct port of digicampusbd's `student-attendance-report-daily-section`
 * ("Date Wise Attendance") — every real recorded attendance row for one
 * class/period/date. Confirmed via `StudentAttendanceService
 * .studentAttendanceListForUpdate` this is a plain filtered/ordered SELECT,
 * no aggregation — reuses the exact same repository finder the "take
 * attendance" grid already uses, but shows only real records (no
 * defaults filled in for unmarked students, unlike the take-attendance
 * grid). New `GET /api/attendance/reports/student/daily-section`.
 */
export default function StudentDailySectionReportPage() {
  const [classConfigs, setClassConfigs] = useState([]);
  const [classConfigId, setClassConfigId] = useState("");
  const [periods, setPeriods] = useState([]);
  const [periodId, setPeriodId] = useState("");
  const [date, setDate] = useState(today());
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    listClassConfigurations().then((configs) => {
      setClassConfigs(configs);
      if (configs.length > 0) setClassConfigId(String(configs[0].id));
    });
    periodApi.list().then((list) => {
      setPeriods(list);
      if (list.length > 0) setPeriodId(String(list[0].id));
    });
  }, []);

  const handleSearch = async () => {
    setError("");
    setLoading(true);
    try {
      setRows(await getStudentDailySection(date, periodId, classConfigId));
    } catch (err) {
      setError("Failed to load attendance report.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Date Wise Attendance</h1>
      </div>
      {error && <p style={{ color: "var(--color-danger)" }}>{error}</p>}
      <div className="attendance-filters">
        <label>
          Section
          <select value={classConfigId} onChange={(e) => setClassConfigId(e.target.value)}>
            {classConfigs.map((c) => (
              <option key={c.id} value={c.id}>
                {c.classConfigName}
              </option>
            ))}
          </select>
        </label>
        <label>
          Period
          <select value={periodId} onChange={(e) => setPeriodId(e.target.value)}>
            {periods.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </label>
        <label>
          Date
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </label>
        <button type="button" className="btn-primary" onClick={handleSearch}>
          Search
        </button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        rows && (
          <div className="table-scroll">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>Student ID</th>
                  <th>Student Name</th>
                  <th>Roll</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i}>
                    <td>{r.customStudentId}</td>
                    <td>{r.studentName}</td>
                    <td>{r.studentRoll}</td>
                    <td>{r.status}</td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan={4}>No attendance recorded for this selection.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )
      )}
    </MainLayout>
  );
}
